/* eslint-disable max-len */
import { QueryKey, useQuery, UseQueryOptions } from 'react-query';

import {
  getForecastedRevenueSummary,
} from '@zero5/payment-api';

import { queryGroupName } from './queryGroupName';
import { mapForecastedRevenueSummary } from './mappings';

type Response = ReturnType<typeof mapForecastedRevenueSummary>;
type Params = {
  from: number;
  until: number;
};

export const queryKey: QueryKey = 'forecastedRevenueSummary';

type Key = [typeof queryGroupName, typeof queryKey, Params];

const useForecastedSummaryQuery = (
  params: Params,
  options?: UseQueryOptions<Response, unknown, Response, Key>,
) => {
  return useQuery<Response, unknown, Response, Key>(
    [queryGroupName, queryKey, params],
    async () => {
      const response = await getForecastedRevenueSummary(params);

      return mapForecastedRevenueSummary(response);
    },
    {
      refetchOnWindowFocus: false,
      ...options,
    },
  );
};

export default useForecastedSummaryQuery;
